<template>
  <div>
    <b-card-code
      title=""
      no-body
    >
      <b-modal
        id="modal-select2"
        v-model="modalShow"
        title="Recover Historical Device Data"
        cancel-variant="outline-secondary"
        size="lg"
        hide-footer
        @cancel="resetSseData"
      >
        <validation-observer ref="simpleRules">
          <b-form @submit.prevent>
            <b-row>
              <!-- Device -->
              <b-col cols="12">
                <b-form-group
                  label="Device"
                  label-for="v-Devices"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Devices"
                    rules="required"
                  >
                    <v-select
                      id="v-Devices"
                      v-model="recoverData.deviceGuid"
                      :options="items"
                      label="code"
                      placeholder="Devices"
                      class="w-100"
                      multiple
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-row>
                  <b-col cols="6">
                    <b-form-group
                      label="StartDate"
                      label-for="v-StartDate"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="StartDate"
                        rules="required"
                      >
                        <b-form-datepicker
                          id="v-StartDate"
                          v-model="recoverData.startTime"
                          placeholder="StartDate"
                          class="w-100"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col cols="6">
                    <b-form-group
                      label="EndDate"
                      label-for="v-EndDate"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="EndDate"
                        rules="required"
                      >
                        <b-form-datepicker
                          id="v-EndDate"
                          v-model="recoverData.endTime"
                          placeholder="EndDate"
                          class="w-100"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="12">
                <b-progress
                  v-if="sseData.isProcessing"
                  :value="sseData.progress"
                  :max="100"
                  show-progress
                  animated
                >
                  <b-progress-bar :value="sseData.progress">
                    {{ sseData.progressMessage + ' ' + sseData.progress + '%' }}
                  </b-progress-bar>
                </b-progress>
              </b-col>
              <b-col
                cols="12"
                class="mt-1 mb-1"
              >
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="primary"
                  :disabled="sseData.isProcessing"
                  @click.prevent="updateDevice"
                >
                  Submit
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-modal>
      <div>
        <b-button
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          class="sidebar-right mr-2"
          variant="primary"
          @click="() => { modalShow=true }"
        >
          <feather-icon icon="PlusIcon" /> Recover Data
        </b-button>
      </div>
      <div><div class="h-50 d-inline-block" /></div>
      <div class="d-flex justify-content-between flex-wrap">
        <!-- sorting  -->
        <b-form-group
          label="Sort"
          label-size="sm"
          label-align-sm="left"
          label-cols-sm="3"
          label-for="sortBySelect"
          class="ml-1"
        >
          <b-input-group size="sm">
            <b-form-select
              id="sortBySelect"
              v-model="sortBy"
              :options="sortOptions"
            >
              <template #first>
                <option value="">
                  none
                </option>
              </template>
            </b-form-select>
            <b-form-select
              v-model="sortDesc"
              size="sm"
              :disabled="!sortBy"
            >
              <option :value="false">
                Asc
              </option>
              <option :value="true">
                Desc
              </option>
            </b-form-select>
          </b-input-group>
        </b-form-group>
        <!-- filter -->
        <b-form-group
          label="Filter"
          label-cols-sm="2"
          label-align-sm="left"
          label-size="sm"
          label-for="filterInput"
          class="mr-1"
        >
          <b-input-group size="sm">
            <b-form-input
              id="filterInput"
              v-model="filter"
              type="search"
              placeholder="Type to Search"
            />
            <b-input-group-append>
              <b-button
                :disabled="!filter"
                @click="filter = ''"
              >
                Clear
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </div>
      <b-table striped hover responsive class="position-relative" :per-page="perPage" :current-page="currentPage" :items="items" :fields="fields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" :filter="filter" :filter-included-fields="filterOn" @filtered="onFiltered">
              <template #cell(created_at)="data">
                {{ dateFormat(data.value) }}
              </template>
              <template #cell(device_value)="row">
                {{ `${row.item.device_value.toFixed(2)} ${row.item.device_default_unit}` }}
              </template>
              <template #cell(device_serial_number)="row">
              <b-link
                :to="{ path: '/temperature-device/detail/' + row.item.device_id }"
              >
                <span>{{ row.item.device_serial_number }}</span>
              </b-link>
            </template>
              <template #cell(device_status)="data">
                <b-badge :variant="status[1][data.value]">
                  {{ status[0][data.value] }}
                </b-badge>
              </template>
              <template #cell(smile_connection_status)="data">
                <b-badge :variant="StatusConnection[1][data.value]">
                  {{ StatusConnection[0][data.value] }}
                </b-badge>
              </template>
              <template #cell(last_send_data)="data">
                {{ formatRelativeTime(data.value) || '-' }}
              </template>
              <template #cell(action)="row">
                <span>
                  <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                    <template v-slot:button-content>
                      <feather-icon icon="MoreVerticalIcon" size="16" class="text-body align-middle mr-25" />
                    </template>
                    <b-dropdown-item>
                      <b-link :to="{ path: '/location/detail/'+ row.item.id}">
                      <feather-icon icon="Edit2Icon" class="mr-50" />
                      <span>Edit</span>
                      </b-link>
                    </b-dropdown-item>
                    <b-dropdown-item>
                      <b-link v-b-modal.modal-center
                      @click="rowOnDelete(row.item.id)">
                      <feather-icon icon="TrashIcon" class="mr-50" />
                      <span>Delete</span>
                      </b-link>
                    </b-dropdown-item>
                  </b-dropdown>
                </span>
              </template>
      </b-table>
      <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
        <!-- page length -->
        <b-form-group label="Per Page" label-cols="6" label-align="left" label-size="sm" label-for="sortBySelect" class="text-nowrap mb-md-0 mr-1">
          <b-form-select id="perPageSelect" v-model="perPage" size="sm" inline :options="pageOptions" />
        </b-form-group>
        <!-- pagination -->
        <div>
          <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" first-number last-number prev-class="prev-item" next-class="next-item" class="mb-0">
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </div>
      </b-card-body>
    </b-card-code>
  </div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
  BFormFile, BCard, BCardText, BTable, BProgress, BProgressBar, BRow, BCol, BImg, BBadge, BForm, BFormDatepicker, BMedia, BMediaAside, BMediaBody, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BCardBody, BLink, BDropdown, BDropdownItem, VBModal,
} from 'bootstrap-vue'
import { mapState } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { required } from '@validations'
import store from '@/store/index'
import { formatRelativeTime } from '@/store/utils'

export default {
  components: {
    ValidationProvider, ValidationObserver, vSelect, BCardCode, BCard, BCardText, BProgress, BProgressBar, BTable, BFormDatepicker, BRow, BFormFile, BMedia, BMediaAside, BMediaBody, BCol, BImg, BBadge, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BCardBody, BLink, BDropdown, BDropdownItem, ToastificationContent, BForm, VBModal,
  },
  directives: {
    Ripple,
    'b-modal': VBModal,
  },
  data() {
    return {
      data: [
        {
          icons: require('@/assets/images/icons/site.png'),
          icon: 'UsersIcon',
          color: 'light-warning',
          title: 0,
          subtitle: 'Total',
          customClass: 'mb-3 mb-xl-0',
        },
        {
          icons: require('@/assets/images/icons/online.png'),
          icon: 'UserIcon',
          color: 'light-info',
          title: 0,
          subtitle: 'Online',
          customClass: 'mb-3 mb-xl-0',
        },
        {
          icons: require('@/assets/images/icons/offline.png'),
          icon: 'DollarSignIcon',
          color: 'light-success',
          subtitle: 'Offline',
          title: 0,
          customClass: 'mb-3 mb-sm-0',
        },
        {
          icons: require('@/assets/images/icons/offline.png'),
          icon: '',
          color: 'light-info',
          title: 0,
          subtitle: 'Error',
          customClass: 'mb-3 mb-xl-0',
        },
      ],
      historicalUrl: '/devices/historical-devices',
      select_device_type: null,
      select_status: null,
      dir: false,
      modalShow: false,
      currentPage: 1,
      perPage: 10,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      StatusOptions: [
        { title: 'Available', value: 'AC' },
        { title: 'Active', value: 'IN' },
        { title: 'Deleted', value: 'DL' },
      ],
      StatusConnection: [
        {
          Connected: "Connected",
          Disconnected: "Disconnected"
        },
        {
          Disconnected: "light-warning",
          Connected: "light-success"
        }
      ],
      status: [{
        AC: 'Available', IN: 'Unavailable', DL: 'Deleted', 4: 'Resigned', 5: 'Applied',
      },
      {
        AC: 'light-success', IN: 'light-danger', DL: 'light-danger', 4: 'light-warning', 5: 'light-info',
      }],
      recoverData: {
        deviceGuid: null,
        startTime: null,
        endTime: null,
      },
      sseData: {
        isProcessing: false,
        progress: 0,
        status: 'start',
        eventSource: null,
        progressMessage: '',
      },
      select_6: '', select_7: '', select_8: '', select_9: '',select_10: '', select_11: '',
      isLoading: false,
      required,
      formatRelativeTime
    }
  },
  computed: {
    ...mapState({
      totalRows: state => state.temperature.device_list.totalRows, 
      fields: state => state.temperature.device_list.fields, 
      items: state => state.temperature.device_list.items, 
      pageOptions: state => state.device.pageOptions,
      DeviceTypeOptions: state => state.temperature.devicetypeoptions,
    }),
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
    dateFormat() {
      return create_at => this.$options.filters.formatDate(create_at)
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        this.dir = true
        return this.dir
      }
      this.dir = false
      return this.dir
    },
  },
  mounted() {
    // Set the initial number of items
    this.$store.state.totalRows = this.items.length
  },
  created() {
    this.params = {
      province_id: this.select_6,
      regency_id: this.select_7,
      district_id: this.select_8,
      device_type_id: this.select_9,
      device_status: this.select_10,
      connection_status: this.select_11
    }
    this.$store.dispatch('temperature/getDashboard', this.params)
    this.$store.dispatch('temperature/getDeviceType')
  },
  methods: {
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.$store.state.totalRows = filteredItems.length
      this.$store.state.totalActive = filteredItems.filter(f => f.status == 'IN').length
      this.$store.state.totalOffline = filteredItems.filter(f => f.status == 'ER').length
      this.$store.state.totalError = filteredItems.filter(f => f.status == 'FL').length
      this.currentPage = 1
      this.data[0].title = this.totalRows
      this.data[1].title = this.totalActive
      this.data[2].title = this.totalOffline
      this.data[3].title = this.totalError
    },
    advanceSearch(val) {
      this.searchTerm = val
    },
    rowOnDelete(id) {
      this.$bvModal
        .msgBoxConfirm('Please confirm that you want to delete everything.', {
          title: 'Please Confirm', size: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'No', cancelVariant: 'outline-secondary', hideHeaderClose: false, centered: true,
        })
        .then(value => {
          if (value === true) {
            // this.$store.dispatch('device/remove', id)
            //   .then(response => {
            //     if (response.status === 200) {
            //       this.$store.dispatch('device/getAll')
            //       this.notification('Success', 'CheckIcon', 'success', 'You have successfully recover data')
            //     } else {
            //       this.notification('Failed', 'CloseIcon', 'danger', 'You have unsuccessful')
            //     }
            //   },
            //   error => {
            //     this.notification('Failed', 'CloseIcon', 'danger', 'You have unsuccessful')
            //   })
          }
        })
    },
    uploadExcel(e) {
      const excelFile = e.target.files[0]
      this.importFile.excelFile = excelFile
    },
    notification(a, b, c, d) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title: a, icon: b, variant: c, text: d,
        },
      })
    },
    resetUpdate(bvModalEvent) {
      bvModalEvent.preventDefault()
      this.modalShow = false
      this.recoverData = {
        deviceGuid: null,
        status: null,
      }
    },
    resetImport(bvModalEvent) {
      bvModalEvent.preventDefault()
      this.importFile = {
        excelFile: null,
      }
    },
    setData() {
      this.$store.dispatch('device/getAll', this.params).then(resp => {
        this.data[0].title = resp.length
        this.data[1].title = resp.filter(
          f => f.status == 'IN',
        ).length
        this.data[2].title = resp.filter(
          f => f.status == 'ER',
        ).length
        this.data[3].title = resp.filter(
          f => f.status == 'FL',
        ).length
      })
    },
    filterz() {
      if (!this.select_device_type) {
        this.select_device_type = ''
      }
      if (!this.select_status) {
        this.select_status = ''
      }
      this.params = {
        select_device_type: this.select_device_type,
        select_device_type: this.select_status,
      }
      this.$store.dispatch('device/getAll', this.params)
    },
    async updateDevice(bvModalEvent) {
      bvModalEvent.preventDefault()
      this.isLoading = true
      try {
        const api = process.env.VUE_APP_REVAMP_ROOT_API
        const isValid = await this.$refs.simpleRules.validate()
        if (!isValid) {
          this.isLoading = false
          return
        }
        this.sseData = {
          ...this.sseData,
          isProcessing: true,
          progress: 0,
          status: 'start',
          eventSource: null,
        }
        const recoveredData = {
          deviceGuid: this.recoverData.deviceGuid.map(device => device.serial_number),
          startTime: this.recoverData.startTime ? Math.floor(new Date(this.recoverData.startTime).getTime() / 1000) : null,
          endTime: this.recoverData.endTime ? Math.floor(new Date(this.recoverData.endTime).getTime() / 1000) : null,
        }
        fetch(api + this.historicalUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(recoveredData),
          credentials: 'include',
        }).then(response => {
          const reader = response.body.getReader()
          const decoder = new TextDecoder()

          const processStream = async () => {
            while (true) {
              let complete = false
              // eslint-disable-next-line no-await-in-loop
              const { done, value } = await reader.read()
              if (done || complete) break

              const chunk = decoder.decode(value, { stream: true })
              const lines = chunk.split('\n\n')

              console.log('lines', lines)
              lines.forEach(line => {
                if (line.startsWith('data: ')) {
                  const jsonData = line.slice(6)
                  try {
                    console.log('json', jsonData)
                    const data = JSON.parse(jsonData)
                    this.handleSSEMessage(data)
                    if (data.status === 'complete') {
                      complete = true
                    }
                  } catch (error) {
                    console.error('Error parsing SSE data:', error)
                  }
                }
              })
            }
          }

          processStream().catch(error => {
            console.error('Error processing stream:', error)
          })
        }).catch(error => {
          this.processFailed(error)
          console.error('Error initiating SSE connection:', error)
        })
      } catch (err) {
        console.log(err)
        this.processFailed(err)
        this.notification('Failed', 'CloseIcon', 'danger', 'You have unsuccessful')
      }
      this.isLoading = false
    },

    handleSSEMessage(data) {
      if (data.status === 'complete') {
        this.processCompleted(data)
      } else if (data.progress !== undefined) {
        this.updateProgress(data.progress, data.message)
      }
    },

    updateProgress(progress, message) {
      this.sseData.progress = progress
      this.sseData.progressMessage = message
    },

    processCompleted() {
      this.params = {
        province_id: this.select_6,
        regency_id: this.select_7,
        district_id: this.select_8,
        device_type_id: this.select_9,
        device_status: this.select_10,
        connection_status: this.select_11
      }
      this.resetSseData()
      this.modalShow = false
      this.notification('Success', 'CheckIcon', 'success', 'You have successfully')
      this.$store.dispatch('device/getAll', this.params)
      if (this.eventSource) {
        this.eventSource.close()
      }
    },

    processFailed(err) {
      this.notification('Failed', 'CloseIcon', 'danger', `You have unsuccessful ${err}`)
      this.$store.dispatch('device/getAll', this.params)
      if (this.eventSource) {
        this.eventSource.close()
      }
    },

    resetSseData() {
      this.sseData = {
        isProcessing: false,
        progress: 0,
        status: 'start',
        eventSource: null,
        progressMessage: '',
      }
      this.recoverData = {
        deviceGuid: null,
        startTime: null,
        endTime: null,
      }
    },
  },
}
</script>

  <style lang="scss">
  @import "@core/scss/vue/libs/vue-select.scss";
  </style>
